export function animateImages(wrapper) {
    if(window.innerWidth >= 1200) {
        const images = wrapper.querySelectorAll("img");
        [...images].forEach(img => {
            const animation = {
                name: img.getAttribute("data-animation"),
                duration: img.getAttribute("data-duration"),
                delay: img.getAttribute("data-delay"),
                timing: img.getAttribute("data-timing")
            };

            img.style.animation = 'none';
            img.offsetHeight; /* trigger reflow */
            img.style.animation = null;

            img.style.animation = `${animation.name} ${animation.duration}s ${animation.timing} ${animation.delay}s forwards`;
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/animate-images.js